export const CONSENT_TO_PROCESS = 'CONSENT_TO_PROCESS';
export const CONSENT_TO_PROCESS_SUCCEEDED = 'CONSENT_TO_PROCESS_SUCCEEDED';
export const CONSENT_TO_COMMUNICATE = 'CONSENT_TO_COMMUNICATE';
export const CONSENT_TO_COMMUNICATE_SUCCEEDED = 'CONSENT_TO_COMMUNICATE_SUCCEEDED';
export const CONSENT_TO_COMMUNICATE_FAILED = 'CONSENT_TO_COMMUNICATE_FAILED';